import { render, staticRenderFns } from "./JobClient.vue?vue&type=template&id=01a5d4e4&scoped=true&"
import script from "./JobClient.vue?vue&type=script&lang=js&"
export * from "./JobClient.vue?vue&type=script&lang=js&"
import style0 from "./JobClient.vue?vue&type=style&index=0&id=01a5d4e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a5d4e4",
  null
  
)

export default component.exports